import { ApolloClient } from '@apollo/client';

/**
 * Used for the Apollo cache on page props.
 */
export const APOLLO_CACHE_KEY = '__APOLLO_CACHE__';

/**
 * Returns an object to spread on the props object during SSR data fetching.
 */
export const getApolloCacheForHydration = (client: ApolloClient) => ({ [APOLLO_CACHE_KEY]: client.cache.extract() });
